import React from 'react'
import './edit-invoice.css'

import {gql, useMutation } from '@apollo/client';
import axios from 'axios';
import { baseUrl } from '../../assets/Animations';
import ExtrasWarningPopup from '../ExtrasWarningPopup/ExtrasWarningPopup';

const EditInvoice = (props) => {

    let CREATE_INVOICE = gql`mutation ($input: InvoiceCreateInput!) {
        invoiceCreate(input: $input) {
          didSucceed
          inputErrors {
            message
            code
            path
          }
          invoice {
            id
            createdAt
            modifiedAt
            pdfUrl
            viewUrl
            status
            title
            subhead
            invoiceNumber
            invoiceDate
            poNumber
            customer {
              id
              name
              # Can add additional customer fields here
            }
            currency {
              code
            }
            dueDate
            amountDue {
              value
              currency {
                symbol
              }
            }
            amountPaid {
              value
              currency {
                symbol
              }
            }
            taxTotal {
              value
              currency {
                symbol
              }
            }
            total {
              value
              currency {
                symbol
              }
            }
            exchangeRate
            footer
            memo
            disableCreditCardPayments
            disableBankPayments
            itemTitle
            unitTitle
            priceTitle
            amountTitle
            hideName
            hideDescription
            hideUnit
            hidePrice
            hideAmount
            items {
              product {
                id
                name
                # Can add additional product fields here
              }
              description
              quantity
              price
              subtotal {
                value
                currency {
                  symbol
                }
              }
              total {
                value
                currency {
                  symbol
                }
              }
              account {
                id
                name
                subtype {
                  name
                  value
                }
                # Can add additional account fields here
              }
              taxes {
                amount {
                  value
                }
                salesTax {
                  id
                  name
                  # Can add additional sales tax fields here
                }
              }
            }
            lastSentAt
            lastSentVia
            lastViewedAt
          }
        }
      }` 

    const [createInvoice, {data}] = useMutation(CREATE_INVOICE)
    const [schoolName, setSchoolName] = React.useState('')
    const [schoolLocation, setSchoolLocation] = React.useState('')
    const [schoolPhoneNumber, setSchoolPhoneNumber] = React.useState('')
    const [schoolWebsite, setSchoolWebsite] = React.useState('')
    const [schoolLogoURL, setSchoolLogoURL] = React.useState('')
    const [invoiceDate, setInvoiceDate] = React.useState('')
    const [paymentDue, setPaymentDue] = React.useState('')
    const [familyInfoPopup, setFamilyInfoPopup] = React.useState(false)
    const [onboardDate, setOnboardDate] = React.useState('')
    const [currentActiveStudents, setCurrentActiveStudents] = React.useState([])
    const [openExtrasWarning, setOpenExtrasWarning] = React.useState(false)
    const [checkingIntroLesson, setCheckingIntroLesson] = React.useState(true)
    const [introWarning, setIntroWarning] = React.useState(false)
    const [liveDatabaseFamilyInformation, setLiveDatabaseFamilyInformation] = React.useState(false)
    const [repeatLesson, setRepeatLesson] = React.useState(false)

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
      if(props.invoice.school === 'mma') {
        setSchoolLocation('Boulder, Colorado')
        setSchoolLogoURL('https://www.mountainsidemusicacademy.com/logo.png')
        setSchoolPhoneNumber('(720) 432-6476')
        setSchoolWebsite('www.mountainsidemusicacademy.com')
        setSchoolName('Mountainside Music Academy')
      }
      if(props.invoice.school === 'lsma') {
        setSchoolLocation('Plymouth, Minnesota')
        setSchoolLogoURL('https://www.lakesidemusicacademy.com/logo.png')
        setSchoolPhoneNumber('(763) 200-4122')
        setSchoolWebsite('www.lakesidemusicacademy.com')
        setSchoolName('Lakeside Music Academy')
      }
      if(props.invoice.school === 'tma') {
        setSchoolLocation('Ann Arbor, Michigan')
        setSchoolLogoURL('https://www.treesidemusicacademy.com/logo.png')
        setSchoolPhoneNumber('(734) 707-9174')
        setSchoolWebsite('www.treesidemusicacademy.com')
        setSchoolName('Treeside Music Academy')
      }
      if(props.invoice.school === 'glma') {
        setSchoolLocation('Evanston, Illinois')
        setSchoolLogoURL('https://www.greatlakesmusicacademy.com/logo.png')
        setSchoolPhoneNumber('(312) 767-8117')
        setSchoolWebsite('www.greatlakesmusicacademy.com')
        setSchoolName('Great Lakes Music Academy')
      }
      if(props.invoice.school === 'mor') {
        setSchoolLocation('Beaverton, Oregon')
        setSchoolLogoURL('https://www.morningsidemusicacademy.com/logo.png')
        setSchoolPhoneNumber('(503) 597-8025')
        setSchoolWebsite('www.morningsidemusicacademy.com')
        setSchoolName('Morningside Music Academy')
      }
      createInvoiceDateAndDueDate()
      checkForPreviousFamilyInvoices()
      getAllOfFamiliesInfo()
    }, [])

    React.useEffect(() => {
      checkForDuplicateLessons()
    })

    const checkForPreviousFamilyInvoices = () => {
      axios.get(`${baseUrl}/invoicesfam/${props.invoice.waveCustomerId}`, myHeader)
      .then((res) => {
        if(res.data.length > 1) {
          setCheckingIntroLesson(false)
        } else {
          setCheckingIntroLesson(false)
          setIntroWarning(true)
        }
      })
      .catch((err) => {
        console.log(err)
      })
    }
    const getAllOfFamiliesInfo = () => {
      axios.get(`${baseUrl}/school-management/${props.invoice.familyId}`, myHeader)
      .then((res) => {
        setLiveDatabaseFamilyInformation(res.data)
      })
      .catch((err) => console.log(err))
    }

    const checkForDuplicateLessons = () => {
      let myMap = {}
      setRepeatLesson(false)
      for(let i = 0; i < props.invoice.lessonsToBeBilled.length; i++) {
        if(myMap[props.invoice.lessonsToBeBilled[i].date]) {
          if(myMap[props.invoice.lessonsToBeBilled[i].date][props.invoice.lessonsToBeBilled[i].studentName]) {
            setRepeatLesson(true)
          } else {
            myMap[props.invoice.lessonsToBeBilled[i].date][props.invoice.lessonsToBeBilled[i].studentName] = true
          }
        } else {
          myMap[props.invoice.lessonsToBeBilled[i].date] = {}
          myMap[props.invoice.lessonsToBeBilled[i].date][props.invoice.lessonsToBeBilled[i].studentName] = true
        }
      }
    }

    const createInvoiceDateAndDueDate = () => {
      let theDate = new Date()
      let myISODate = theDate.toISOString().split('T')[0]
      let invoiceDate;
      let paymentDue;
      if(myISODate.split('-')[2] > 21) {
        let flippedDate = new Date(theDate.getFullYear(), ((theDate.getMonth())%12 + 1), 1)
        invoiceDate = flippedDate.toISOString().split('T')[0]
        paymentDue = new Date(theDate.getFullYear(), ((theDate.getMonth())%12 + 1), flippedDate.getDate() + 7).toISOString().split('T')[0]
      } else {
        invoiceDate = theDate.toISOString().split('T')[0]
        paymentDue = new Date(theDate.setDate(theDate.getDate() + 7)).toISOString().split('T')[0]
      }
      setInvoiceDate(invoiceDate)
      setPaymentDue(paymentDue)
    }

    const createDescriptionStringForLesson = (invoice, i) => {
      let fixedDay = invoice.lessonsToBeBilled[i].date
      //REMOVE FIRST 0
      if(invoice.lessonsToBeBilled[i].date.charAt(0) === '0') {
        fixedDay = invoice.lessonsToBeBilled[i].date.substring(1)
      }
      return `${invoice.monthNumber}/${fixedDay}: ${invoice.lessonsToBeBilled[i].studentName}: ${invoice.lessonsToBeBilled[i].lessonLength}min\n`
    }

    const checkIfThereAreAnyExtrasBeforeSubmittingInvoiceToWave = () => {
      if(props.invoice.extrasToBeBilled.length > 0) {
        setOpenExtrasWarning(true)
      } else {
        makeANewWaveInvoice(props.invoice)
      }
    }

    const closeExtrasPopupAndSubmitInvoiceToWave = () => {
      setOpenExtrasWarning(false)
      makeANewWaveInvoice(props.invoice)
    }

    const makeANewWaveInvoice = async (invoice) => {
      //START LOADING MOUSE
      document.body.style.cursor = 'wait'
      document.getElementById('admin-invoice-submit-btn-for-loading').style.cursor = "wait"
      //-------------------

      axios.post(`${baseUrl}/updateinvoice`, {
        invoice: invoice
      })
      .then((res) => {

          // props.setLoading(`Invoicing ${family[0].allData.FamilyName}...`)
          let businessId;
          let fifteen;
          let thirty;
          let fourtyFive;
          let sixty;
          let theProduct;
          let intro;
          let intro45;
          let intro60;
          if(invoice.school.toUpperCase() === 'MMA') {
              businessId = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBh"
              fifteen = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBhO1Byb2R1Y3Q6NjUyNzYxNjE="
              thirty = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBhO1Byb2R1Y3Q6NTgzMDA1NTI="
              fourtyFive = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBhO1Byb2R1Y3Q6NTgzMDA1NzY="
              sixty = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBhO1Byb2R1Y3Q6NTgzMDA1OTI="
              intro = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBhO1Byb2R1Y3Q6NTgzMzQ3Mzk="
              intro45 = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBhO1Byb2R1Y3Q6ODAwNzAxNTg="
              intro60 = "QnVzaW5lc3M6ZDVlMTRiODMtZDM1OC00MzVlLWI3ZWQtMzU2ZjAzNDAzYzBhO1Byb2R1Y3Q6Mzk3OTk4MzQ="
          } else if (invoice.school.toUpperCase() === 'LSMA') {
              businessId = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2"
              fifteen = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2O1Byb2R1Y3Q6Njg5NjI3MDc="
              thirty = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2O1Byb2R1Y3Q6NTgzMDA2MTM="
              fourtyFive = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2O1Byb2R1Y3Q6NTgzMDA2MzQ="
              sixty = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2O1Byb2R1Y3Q6NTgzMDA2NDU="
              intro = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2O1Byb2R1Y3Q6NTgzMzc3NTk="
              intro45 = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2O1Byb2R1Y3Q6NTgzMzc3NTk="
              intro60 = "QnVzaW5lc3M6NGYxNWJhZGItYTc4Zi00ZjIxLWE2MDEtYmY0YjA2ZDVlNzk2O1Byb2R1Y3Q6NTgzMzc3NTk="
          } else if (invoice.school.toUpperCase() === 'TMA') {
              businessId = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDky"
              fifteen = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDkyO1Byb2R1Y3Q6Njg5NjI3MzM="
              thirty = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDkyO1Byb2R1Y3Q6NTgzMDA2NzE="
              fourtyFive = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDkyO1Byb2R1Y3Q6NTgzMDA2ODM="
              sixty = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDkyO1Byb2R1Y3Q6NTgzMDA2ODc="
              intro = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDkyO1Byb2R1Y3Q6NTgzMzc3OTc="
              intro45 = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDkyO1Byb2R1Y3Q6NTgzMzc3OTc="
              intro60 = "QnVzaW5lc3M6OGMyMGUyN2YtZTQ2MC00ZGI2LWI1M2ItNGNhNzMxYTMyNDkyO1Byb2R1Y3Q6NTgzMzc3OTc="
          } else if (invoice.school.toUpperCase() === 'MOR') {
              businessId = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQw"
              fifteen = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQwO1Byb2R1Y3Q6NzkwMzIxNzU="
              thirty = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQwO1Byb2R1Y3Q6NzkwMzIxODU="
              fourtyFive = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQwO1Byb2R1Y3Q6NzkwMzIyMTU="
              sixty = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQwO1Byb2R1Y3Q6NzkwMzIyMjg="
              intro = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQwO1Byb2R1Y3Q6NzkwMzI0ODk="
              intro45 = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQwO1Byb2R1Y3Q6NzkwMzI0ODk="
              intro60 = "QnVzaW5lc3M6MjgxYzUwZmQtMjg0Yi00MzMyLTk5NjEtN2Y3MjNkMDRkZmQwO1Byb2R1Y3Q6NzkwMzI0ODk="
          } else {
              return
          }
          let familyItems = []
          let studentNameKeys = []
          let compilerObject = {}

          for(let i = 0; i < invoice.lessonsToBeBilled.length; i++) {
              if(invoice.lessonsToBeBilled[i].lessonLength === 30) {
                  theProduct = thirty
              } else if (parseInt(invoice.lessonsToBeBilled[i].lessonLength) === 15){
                  theProduct = fifteen
              } else if (parseInt(invoice.lessonsToBeBilled[i].lessonLength) === 45) {
                  theProduct = fourtyFive
              } else if (parseInt(invoice.lessonsToBeBilled[i].lessonLength) === 60) {
                  theProduct = sixty
              } else if (parseInt(invoice.lessonsToBeBilled[i].lessonLength) === 31) {
                  theProduct = intro
              } else if (parseInt(invoice.lessonsToBeBilled[i].lessonLength) === 46) {
                  theProduct = intro45
              } else if (parseInt(invoice.lessonsToBeBilled[i].lessonLength) === 61) {
                  theProduct = intro60
              }
              //NAME ALREADY EXISTS
              let studentNameAndLessonLengthString = `${invoice.lessonsToBeBilled[i].studentName}-${invoice.lessonsToBeBilled[i].lessonLength}`
              if(studentNameKeys.includes(studentNameAndLessonLengthString)) {
                compilerObject[studentNameAndLessonLengthString] = {
                  "productId": theProduct,
                  "description": compilerObject[studentNameAndLessonLengthString]["description"] + createDescriptionStringForLesson(invoice, i),
                  "quantity": compilerObject[studentNameAndLessonLengthString]["quantity"] + 1,
                  "unitPrice": findStudentRate(invoice.lessonsToBeBilled[i], invoice.lessonsToBeBilled[i].studentName, invoice.lessonsToBeBilled[i].lessonLength)
                }
              } else {
                studentNameKeys.push(studentNameAndLessonLengthString)
                compilerObject[studentNameAndLessonLengthString] = {
                  "productId": theProduct,
                  "description": createDescriptionStringForLesson(invoice, i),
                  "quantity": 1,
                  "unitPrice": findStudentRate(invoice.lessonsToBeBilled[i], invoice.lessonsToBeBilled[i].studentName, invoice.lessonsToBeBilled[i].lessonLength)
                }
              }
          }
          for(let i = 0; i < studentNameKeys.length; i++) {
            familyItems.push(compilerObject[studentNameKeys[i]])
          }
          let createInvoiceVariables = 
          {
            "input": {
              "businessId": businessId,
              "customerId": invoice.waveCustomerId,
              "invoiceDate": invoiceDate,
              "dueDate": paymentDue,
              "items": familyItems
            }
          }
          return createInvoice({variables: createInvoiceVariables})
                  .then((res) => {
                      markInvoiceAsSubmittedAndCloseModal()
                      return res

                  })
                  .catch((err) => {
                      console.log(err)
                      console.log(err.networkError.result.errors)
                      console.log(`Error invoicing`)
                      props.setLoading(false)
                  })
      })
      .catch((err) => {
        console.log(err)
        alert('Invoice did not save and was not sent to Wave')
      })
    }

    const markInvoiceAsSubmittedAndCloseModal = () => {
      axios.post(`${baseUrl}/approveinvoice`, {
        invoiceId: props.invoice.invoiceId
      })
      .then((res) => {

        //STOP LOADING MOUSE
        document.body.style.cursor = 'default'
        document.getElementById('admin-invoice-submit-btn-for-loading').style.cursor = "default"
        //------------------

        props.updateInvoices(res.data)
        props.setOpenInvoice(false)
      })
      .catch((err) => {
        console.log(err)
      })
    }

    const findStudentRate = (lesson, nameOnInvoice, lengthOfLesson) => {
      let found = false
      if(parseInt(lengthOfLesson) === 31 || parseInt(lengthOfLesson) === 46 || parseInt(lengthOfLesson) === 61) {
        found = true
        if(parseInt(lengthOfLesson) === 31) {
          return 25
        } else if (parseInt(lengthOfLesson) === 46) {
          return 35
        } else if (parseInt(lengthOfLesson) === 61) {
          return 45
        }
      } else {
        if(lesson.studentAllRates) {
          return lesson.studentAllRates[lengthOfLesson]
        } else {
        //-----------THIS IS GOING OFF OF WHAT THE STUDENTS RATE WAS BASED OFF OF REAL TIME DATABASE RATE
          for(let i = 0; i < props.invoice.familyInfo.students.length; i++) {
            if(props.invoice.familyInfo.students[i].studentName === nameOnInvoice) {
                found = true
                if(!props.invoice.familyInfo.students[i].allRates) {
                  return props.invoice.familyInfo.students[i].lessonRate
                } else {
                  return props.invoice.familyInfo.students[i].allRates[lengthOfLesson]
                }
            }
        }
        }
      }
      if(!found) {
          //alert('Student does not exist in the database. Either change student name or go to Student Database and add student to family.')
          return 0
      }
    }

    const estimateCharge = () => {
        let total = 0
        for(let i = 0; i < props.invoice.lessonsToBeBilled.length; i++) {
            total = Math.floor(parseInt(total) + parseInt(findStudentRate(props.invoice.lessonsToBeBilled[i], props.invoice.lessonsToBeBilled[i].studentName, props.invoice.lessonsToBeBilled[i].lessonLength)))
        }
        for(let i = 0; i < props.invoice.extrasToBeBilled.length; i++) {
          total = Math.floor(parseInt(total) + parseInt(props.invoice.extrasToBeBilled[i].amount))
        }
        return total
    }

    const closeAndSaveInvoice = (invoice) => {
      //IF EDITTING INVOICE
      if(props.editting) {
        document.body.style.cursor = 'wait' 
        axios.post(`${baseUrl}/updateinvoice`, {
          invoice: invoice
        })
        .then((res) => {
          document.body.style.cursor = 'default' 
          props.updateInvoices(res.data)
          props.setOpenInvoice(false)
        })
        .catch((err) => {
          document.body.style.cursor = 'default' 
          console.log(err)
        })
      } 
      //IF CREATING AN INVOICE
      else {
        props.setAdminCreateInvoice(false)
      }
    }

    const editOpenedInvoice = (key1, key2, index, value) => {
      let updatedInvoice = props.invoice
      if(key1 === 'lessonsToBeBilled') {
        updatedInvoice.lessonsToBeBilled[index][key2] = value
      }
      props.setOpenInvoice({...updatedInvoice})
    }

    const removeLesson = (index) => {
      let updatedInvoice = props.invoice
      updatedInvoice.lessonsToBeBilled.splice(index, 1)
      props.setOpenInvoice({...updatedInvoice})
    }

    const addALesson = () => {
      let updatedInvoice = props.invoice
      updatedInvoice.lessonsToBeBilled.push({
        id: Math.random().toString(16).slice(2),
        studentName: '',
        lessonLength: 30,
        date: '0',
        lessonRate: 0
      })
      props.setOpenInvoice({...updatedInvoice})
    }

    const toggleFamilyPopup = (bool) => {
      if(onboardDate === '') {
        axios.get(`${baseUrl}/family-lookup/${props.invoice.waveCustomerId}`, myHeader)
        .then((res) => {
          let myDate = new Date(res.data.onboardDate).toISOString().split('T')[0]
          setOnboardDate(myDate)
          let activeStudents = []
          for(let i = 0; i < res.data.students.length; i++) {
            if(res.data.students[i].studentStatus === 'Active') {
              activeStudents.push(res.data.students[i].studentName)
            }
          }
          setCurrentActiveStudents(activeStudents)
        })
      }
      setFamilyInfoPopup(bool)
    }

    const closeOnWrapperClick = (id) => {
      if(id === 'edit-timesheet-wrapper__new') {
        //props.setOpenInvoice(false)
        closeAndSaveInvoice(props.invoice)
      }
    }

    const deleteInvoice = (id) => {
      axios.delete(`${baseUrl}/invoices/${id}`, myHeader)
      .then((res) => {
        props.removeDeletedInvoice(res.data.invoiceId)
        props.setOpenInvoice(false)
      })
      .catch((err) => {
        console.log(err)
      })
    }

    const createTheInvoice = (invoice) => {
      axios.post(`${baseUrl}/invoices`, {
        invoiceId: invoice.invoiceId,
        familyId: invoice.familyInfo.familyId,
        familyName: invoice.familyInfo.familyName,
        waveCustomerId: invoice.waveCustomerId,
        monthYear: invoice.monthYear,
        lessonsToBeBilled: invoice.lessonsToBeBilled,
        extrasToBeBilled: invoice.extrasToBeBilled,
        email: invoice.familyInfo.primaryEmail,
        //amount: req.body.teacherInvoice.amount,
        status: 'Created',
        school: invoice.school,
        paymentMethod: '',
        teachers: [],
        autoPay: false,
        monthNumber: invoice.monthNumber,
        year: invoice.year
      }, myHeader)
      .then((res) => {
        props.addInvoiceAndClose(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
    }

    const changeTheStudentsRateForSpecificLessonLength = (lessonId, lessonLength, newRate) => {
      let updatedInvoice = props.invoice
      for(let i = 0; i < updatedInvoice.lessonsToBeBilled.length; i++) {
        if(updatedInvoice.lessonsToBeBilled[i].id === lessonId) {
          updatedInvoice.lessonsToBeBilled[i].studentAllRates[lessonLength] = newRate
        }
      }
      props.setOpenInvoice({...updatedInvoice})
    }

    return(
        <div className="edit-timesheet-wrapper__new" id="edit-timesheet-wrapper__new" onClick = {(e) => closeOnWrapperClick(e.target.id)}>
          {openExtrasWarning && <ExtrasWarningPopup setOpenExtrasWarning={setOpenExtrasWarning} extras={props.invoice.extrasToBeBilled} closeExtrasPopupAndSubmitInvoiceToWave={closeExtrasPopupAndSubmitInvoiceToWave} />}
            <div className="create-timesheet edit-invoice-wrapper">
                <div className="another-x-wrapper">
                    <h3 className="close-create-timesheet-x" onClick={() => closeAndSaveInvoice(props.invoice)}>X</h3>
                </div>
                <div className="invoice-header-section">
                  <div className="header-words-section but-make-it-on-the-left">
                    <img alt='school-logo' className="invoice-school-logo" src={schoolLogoURL}/>
                    {familyInfoPopup && <div className="family-info-popup">{onboardDate}{currentActiveStudents.length > 0 && currentActiveStudents.map((student) => <p key={student} className="student-name-in-family-info-popup">{student}</p>)}</div>}
                  </div>
                  <div className="header-words-section">
                    <div className="invoice-header-title-invoice">INVOICE</div>
                    <div className="invoice-header-title-school-name">{schoolName}</div>
                    <div>{schoolLocation}</div>
                    <div className="invoice-header-title-country">United States</div>
                    <div>{schoolPhoneNumber}</div>
                    <div>{schoolWebsite}</div>
                  </div>
                </div>
                <div className="bill-to-section-left-side">
                  <div className="bill-to-section-left-bill-to">Bill to</div>
                  <div className="bill-to-section-left-family-name" onMouseEnter={() => toggleFamilyPopup(true)} onMouseLeave={() => toggleFamilyPopup(false)}>{props.invoice.familyName}</div>
                  {liveDatabaseFamilyInformation && liveDatabaseFamilyInformation.autoPay && <div className="bill-to-section-left-auto-pay">AUTO-PAY</div>}
                  <div className="bill-to-section-left-first-name">{props.invoice.familyInfo.primaryParentName} {props.invoice.familyName}</div>
                  <div className="bill-to-section-left-address">{props.invoice.familyInfo.address.addressLine1} {props.invoice.familyInfo.address.city} {props.invoice.familyInfo.address.state}</div>
                  <div className="bill-to-section-left-cellphone">{props.invoice.familyInfo.primaryCellphone}</div>
                  <div className="bill-to-section-left-primary-email">{props.invoice.familyInfo.primaryEmail}</div>
                </div>
                <div className="bill-to-section-right-side">
                  <div className="bill-to-section-right-invoice-id"><strong>Invoice ID:</strong> {props.invoice.invoiceId}</div>
                  <div className="bill-to-section-right-invoice-date"><strong>Invoice For:</strong> {props.invoice.monthYear}</div>
                  <div className="bill-to-section-right-invoice-date"><strong>Invoice Date:</strong> {invoiceDate}</div>
                  <div className="bill-to-section-right-invoice-date"><strong>Payment Due:</strong> {paymentDue}</div>
                  <div className="bill-to-section-right-amount-due"><strong>Amount Due: (USD): ${estimateCharge()}</strong></div>
                  {(() => {
                    switch(props.invoice.status) {
                      case 'In Wave':
                        return <div className="bill-to-section-right-in-wave">{props.invoice.status}</div>
                      case 'Scholarship':
                        return <div className="bill-to-section-right-scholarship">{props.invoice.status}</div>
                      default:
                        return <div className="bill-to-section-right-status-submitted">{props.invoice.status}</div>
                    }
                  })()}
                </div>
                {checkingIntroLesson && <div className='invoice__check-for-loading'>checking for other invoices</div>}
                {introWarning && <div className='invoice__check-for-intro'>Check For Intro</div>}
                <div className="invoice-lesson-header">Lessons</div>
                {repeatLesson && 
                  <div className='invoice-lesson-header__repeat-warning__wrapper'>
                    <div className='invoice-lesson-header__repeat-warning'>REPEAT LESSON WARNING</div>
                  </div>
                }
                <div className="family-card-section-for-invoice">
                    {props.invoice.lessonsToBeBilled.map((less, index) => 
                      <div key={less.id} className="edit-invoice-lesson-strip">
                        <p className="delete-lesson-x" onClick={() => removeLesson(index)}>x</p>
                          <select className="choose-student-input-dropdown" value={less.studentName} placeholder="Student" onChange={(e) => editOpenedInvoice('lessonsToBeBilled', 'studentName',index, e.target.value)} >
                              <option value="" default>Choose Student</option>
                              {
                                  props.invoice.familyInfo.students.map((student) => (
                                      <option key={student.studentId} value={student.studentName}>{student.studentName}</option>
                                  ))
                              }
                          </select>
                          <p className="month-number-p">{props.invoice.monthNumber}/</p><input className="invoice-edit-enter-date" value={less.date} onChange={(e) => editOpenedInvoice('lessonsToBeBilled', 'date',index, e.target.value)}/>
                          {/* <input className="lessons-length-spacer invoice-edit-enter-date" value={less.lessonLength} onChange={(e) => editOpenedInvoice('lessonsToBeBilled', 'lessonLength',index, e.target.value)}/><p className="minute-p">min</p> */}
                          <select className='lessons-length__new-dropdown' value={less.lessonLength} onChange={(e) => editOpenedInvoice('lessonsToBeBilled', 'lessonLength',index, e.target.value)}>
                            <option value={15}>15 min</option>
                            <option value={30}>30 min</option>
                            <option value={45}>45 min</option>
                            <option value={60}>60 min</option>
                            <option value={31}>30 min Intro</option>
                            <option value={46}>45 min Intro</option>
                            <option value={61}>60 min Intro</option>
                          </select>
                          <p>$</p><input className="invoice-edit-enter-date" value={findStudentRate(less, less.studentName, less.lessonLength)} onChange={(e) => changeTheStudentsRateForSpecificLessonLength(less.id, less.lessonLength, e.target.value)}/>
                      </div>
                    )}
                    <div className="add-lesson-to-invoice-btn" onClick={() => addALesson()}>+ Add Lesson</div>
                </div>
                {props.invoice.extrasToBeBilled.length > 0 && <div className="invoice-lesson-header">Extras (not added to Wave!)</div>}
                <div className="family-card-section-for-invoice-extras">
                    {props.invoice.extrasToBeBilled.map((extra, index) => 
                    <div key={extra.id} className="edit-invoice-lesson-strip">
                        <p>{extra.description}</p>
                        <p>${extra.amount}</p>
                    </div>
                    )}
                </div>
                <div className="create-timesheet-bottom-sections">
                    <h3 className="create-timesheet__estimated-pay">Estimate Charge: ${estimateCharge()}</h3>
                    <div>
                       {props.editting && <div className="admin-timesheet-submit-btn solid-red" onClick={() => deleteInvoice(props.invoice.invoiceId)}>Delete Invoice</div>}
                       {/* <div className="admin-timesheet-submit-btn clear-green" onClick={() => closeAndSaveInvoice(props.invoice)}>Save and close</div>  */}
                       {props.editting && props.invoice.status !== 'Scholarship' && <div id="admin-invoice-submit-btn-for-loading" className="admin-timesheet-submit-btn solid-green" onClick={() => checkIfThereAreAnyExtrasBeforeSubmittingInvoiceToWave()}>Send Invoice To Wave</div>}
                       {!props.editting && <div className="admin-timesheet-submit-btn solid-green" onClick={() => createTheInvoice(props.invoice)}>Save Invoice</div>}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default EditInvoice